import { AbstractControl, ValidationErrors } from '@angular/forms';

export class FormTransformer {
  public static clearDobuleSpace(control: AbstractControl): ValidationErrors | null {
    if (!control?.value) {
      return null;
    }
    const normalizedValue = control.value.replace(/\s+/g, ' ');
    if (control?.value !== normalizedValue) {
      control.setValue(normalizedValue, { emitEvent: false });
    }
    return null;
  }

  public static clearDobuleDots(control: AbstractControl): ValidationErrors | null {
    if (!control?.value) {
      return null;
    }
    const normalizedValue = control.value.replace(/\.{2}/g, '.');
    if (control?.value !== normalizedValue) {
      control.setValue(normalizedValue, { emitEvent: false });
    }
    return null;
  }

  public static clearDobuleDash(control: AbstractControl): ValidationErrors | null {
    if (!control?.value) {
      return null;
    }
    const normalizedValue = control.value.replace(/\-{2}/g, '-');
    if (control?.value !== normalizedValue) {
      control.setValue(normalizedValue, { emitEvent: false });
    }
    return null;
  }

}

